import { CartLinesUpdateEvent } from '@shopify/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

document.addEventListener('change', (e) => {
  const select = e.target instanceof Element ? e.target.closest('select[data-dc-variant]') : null;
  if (!select) return;
  const card = select.closest('[data-dc-addon]');
  const img = card && card.querySelector('img');
  const opt = select.selectedOptions[0];
  if (img && opt && opt.dataset.img) {
    img.src = opt.dataset.img;
    img.removeAttribute('srcset');
  }
});

document.addEventListener('click', async (e) => {
  const btn = e.target instanceof Element ? e.target.closest('[data-dc-add]') : null;
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const card = btn.closest('[data-dc-addon]');
  const input = card && card.querySelector('[data-dc-variant]');
  const id = input ? Number(input.value) : 0;
  if (!id) return;

  const label = btn.innerHTML;
  btn.disabled = true;
  btn.textContent = '…';

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const json = await res.json();
    if (json.status) throw new Error(json.description || json.message || 'Error');
    const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'dc-addons', itemCount: 1, sections: json.sections, didError: false },
    });
    if (btn.isConnected) {
      btn.textContent = btn.dataset.added || '✓';
      btn.classList.add('is-added');
      setTimeout(() => {
        btn.innerHTML = label;
        btn.disabled = false;
        btn.classList.remove('is-added');
      }, 2500);
    }
  } catch (err) {
    deferred.reject(err);
    btn.textContent = btn.dataset.unavailable || '✕';
    setTimeout(() => {
      btn.innerHTML = label;
      btn.disabled = false;
    }, 2500);
  }
});
